import Icon from "../icons/Icon";
// src/components/dashboard/PayrollApprovalCard.js
// Dashboard card — pending payroll approval queue summary.
// Visibility gated by `payroll:approve` via src/config/dashboardCards.js.
// Component returns null if payrollApprovalSummary hasn't loaded yet.
// See PRD_PayrollApproval.md §UI Surfaces — Dashboard card.

export const PayrollApprovalCard = ({ payrollApprovalSummary, navigate, company }) => {
  if (!payrollApprovalSummary) return null;

  const pending = payrollApprovalSummary.pendingApproval || 0;

  return (
    <div className="dashboard-card">
      <div className="dashboard-card__header">
        <span className="dashboard-card__title">Payroll Approval</span>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            navigate(`/company/${company.slug}/payroll-approval`);
          }}
          className="dashboard-card__link"
        >
          Review →
        </a>
      </div>
      {pending > 0 ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 16,
            padding: 16,
            background: "var(--ui-accent-tint)",
            border: "1px solid var(--ui-accent)",
            borderRadius: 10,
            marginBottom: 16,
            cursor: "pointer",
          }}
          onClick={() => navigate(`/company/${company.slug}/payroll-approval`)}
        >
          <div
            style={{
              width: 44,
              height: 44,
              borderRadius: 10,
              background: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              fontSize: 20,
            }}
          >
            <Icon name="wallet" size={20} />
          </div>
          <div style={{ flex: 1 }}>
            <div
              style={{
                fontSize: 28,
                fontWeight: 700,
                color: "var(--ui-warning-text)",
                fontVariantNumeric: "tabular-nums",
                lineHeight: 1,
              }}
            >
              {pending}
            </div>
            <div style={{ fontSize: 13, color: "var(--ui-warning-text)", fontWeight: 500 }}>
              {pending === 1 ? "Payroll run awaiting approval" : "Payroll runs awaiting approval"}
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            padding: 16,
            textAlign: "center",
            color: "var(--ui-text-muted)",
            fontSize: 14,
          }}
        >
          No payroll runs awaiting approval
        </div>
      )}
    </div>
  );
};
